/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summary_Smpte_LabelInputs */



/**
* | output |
* | --- |
* | "SMPTE" |
*
* @param {Summary_Smpte_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const summary_smpte_label = /** @type {((inputs?: Summary_Smpte_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summary_Smpte_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("SMPTE")
	if (locale === "de") return /** @type {LocalizedString} */ ("SMPTE")
	if (locale === "it") return /** @type {LocalizedString} */ ("SMPTE")
	if (locale === "ru") return /** @type {LocalizedString} */ ("СМПТЕ")
	if (locale === "es") return /** @type {LocalizedString} */ ("SMPTE")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("SMPTE")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SMPTE")
	if (locale === "hi") return /** @type {LocalizedString} */ ("SMPTE")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("SMPTE")
	return /** @type {LocalizedString} */ ("SMPTE")
});